import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var StyledQuote = /*#__PURE__*/ styled("q", {
    target: "e1j3jnmf0"
})("quotes:'„ ' ' “' '\xbb' '\xab';color:", Color.secondary100, ";font-style:italic;font-size:0.75rem;margin-bottom:0.625rem;");
export { StyledQuote };
